import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  class: "block"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "dialog-footer"
};
import { reactive, getCurrentInstance, ref, onMounted, onUnmounted } from 'vue';
import { projectLogSearch_data } from '../../../utils/lc_data';
import { exportlistlog } from "../../../utils/lc";
import { useRouter, useRoute } from 'vue-router';
/* 数据层 */

export default {
  __name: 'prlog',
  setup(__props) {
    let route = useRoute();
    // 基本信息组件值
    const {
      proxy
    } = getCurrentInstance();
    let formdata = reactive(JSON.parse(JSON.stringify(projectLogSearch_data)));
    const data = reactive({
      prlistTtable: [],
      xtshow: false,
      selRow: [],
      total: 0,
      projectId: '',
      page: 1,
      content: '',
      dialogVisible: false
    });
    /* 初始化 */
    const theSearch = ref();
    const keyDown = e => {
      if (e.keyCode == 13 || e.keyCode == 100) {
        searchhandle(JSON.parse(JSON.stringify(theSearch.value.theformdata)));
      }
    };
    onMounted(() => {
      if (window.sessionStorage.getItem("projectLogSearchdata")) {
        formdata = theSearch.value.theformdata;
      }
      if (route.query && route.query.projectName) {
        theSearch.value.theformdata.keywords = route.query.projectName;
      }
      getlist();
      //绑定监听事件
      window.addEventListener('keydown', keyDown);
    });
    onUnmounted(() => {
      //销毁事件
      window.removeEventListener('keydown', keyDown, false);
    });
    /* 方法层 */
    //获取列表数据
    // 点击弹框显示变更内容
    function openInfo(content) {
      data.content = content;
      data.dialogVisible = true;
    }
    function getlist() {
      let sudata = JSON.parse(JSON.stringify(formdata));
      sudata.start_time = sudata.thetime && sudata.thetime.length > 0 ? sudata.thetime[0] : '';
      sudata.end_time = sudata.thetime && sudata.thetime.length > 0 ? sudata.thetime[1] : '';
      // sudata.project_id = route.query && route.query.project_id ? route.query.project_id : ''
      proxy.$http.showLoading(false).get('project/log/list', sudata).then(res => {
        if (res.errno == 200) {
          data.prlistTtable = res.data.data;
          data.total = res.data.total;
        }
      });
    }
    function logexportbt() {
      let sudata = {};
      let thedata = JSON.parse(JSON.stringify(formdata));
      sudata.start_time = thedata.thetime && thedata.thetime.length > 0 ? thedata.thetime[0] : '';
      sudata.end_time = thedata.thetime && thedata.thetime.length > 0 ? thedata.thetime[1] : '';
      sudata.keywords = thedata.keywords;
      sudata.user_name = thedata.user_name;
      sudata.type = thedata.type;
      sudata.module = thedata.module;
      // sudata.task_id = route.query && route.query.task_id ? route.query.task_id : ''
      // sudata.project_id = route.query && route.query.project_id ? route.query.project_id : ''
      exportlistlog(sudata, '项目流程管理日志');
    }
    // 搜索
    function searchhandle(value) {
      if (value) {
        formdata = value;
      }
      data.page = 1;
      formdata.page = 1;
      getlist();
      console.log('搜索', value);
    }
    // 重置
    function resethandel() {
      formdata = JSON.parse(JSON.stringify(projectLogSearch_data));
      data.page = 1;
      formdata.page = 1;
      getlist();
    }
    //分页条数
    function handleSizeChange(val) {
      formdata.size = val;
      data.page = 1;
      formdata.page = 1;
      getlist();
    }

    //分页数
    function handleCurrentChange(val) {
      formdata.page = val;
      data.page = val;
      getlist();
    }
    return (_ctx, _cache) => {
      const _component_lcSearch = _resolveComponent("lcSearch");
      const _component_vxe_column = _resolveComponent("vxe-column");
      const _component_vxe_table = _resolveComponent("vxe-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_main = _resolveComponent("el-main");
      return _openBlock(), _createBlock(_component_el_main, {
        class: "bg_white wrap_box lcpg"
      }, {
        default: _withCtx(() => [_createVNode(_component_lcSearch, {
          class: "lcS",
          ref_key: "theSearch",
          ref: theSearch,
          onSearchhandle: searchhandle,
          onResethandel: resethandel,
          onLogexportbt: logexportbt,
          type: "log"
        }, null, 512), _createElementVNode("div", null, [_createVNode(_component_vxe_table, {
          id: "wlbjtable",
          onCheckboxChange: _ctx.selectionChange,
          onCheckboxAll: _ctx.selectionChange,
          "max-height": "620",
          "custom-config": {
            storage: true
          },
          border: "",
          "show-overflow": "",
          data: data.prlistTtable,
          "keep-source": "",
          "column-config": {
            resizable: true
          },
          "edit-config": {
            trigger: 'click',
            mode: 'cell',
            showUpdateStatus: true,
            showInsertStatus: true
          },
          class: "ggdycss"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "id",
            title: "序号",
            width: "80",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "project_code",
            title: "项目编码",
            width: "80",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "project_name",
            title: "项目名称",
            width: "130",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "user_name",
            title: "变更人",
            width: "130",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "module",
            title: "变更对象",
            width: "130",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "type_text",
            title: "变更类型",
            width: "130",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "createtime",
            title: "变更时间",
            width: "170",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "content",
            title: "变更内容",
            align: "left"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", {
              onClick: $event => openInfo(row.content),
              style: {
                "cursor": "pointer"
              }
            }, _toDisplayString(row.content), 9, _hoisted_1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["onCheckboxChange", "onCheckboxAll", "data"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_pagination, {
          background: "",
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          "current-page": data.page,
          "page-sizes": [50, 100, 150],
          "page-size": _unref(formdata).size,
          layout: "total, sizes, prev, pager, next, jumper",
          total: data.total
        }, null, 8, ["current-page", "page-size", "total"])])]), _createVNode(_component_el_dialog, {
          title: "变更内容",
          modelValue: data.dialogVisible,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.dialogVisible = $event),
          width: "50%",
          "before-close": _ctx.handleClose,
          style: {
            "height": "600px"
          }
        }, {
          footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = $event => data.dialogVisible = false)
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("确 定")])),
            _: 1,
            __: [2]
          })])]),
          default: _withCtx(() => [_createElementVNode("div", {
            innerHTML: data.content,
            style: {
              "white-space": "pre-line",
              "max-height": "500px",
              "overflow": "auto"
            }
          }, null, 8, _hoisted_3)]),
          _: 1
        }, 8, ["modelValue", "before-close"])]),
        _: 1
      });
    };
  }
};